import(/* webpackMode: "eager", webpackExports: ["SessionProvider"] */ "/Users/ghadygergis/Documents/scitrials-sst/node_modules/next-auth/react.js");
;
import(/* webpackMode: "eager" */ "/Users/ghadygergis/Documents/scitrials-sst/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/Users/ghadygergis/Documents/scitrials-sst/packages/website/src/app/global.css");
;
import(/* webpackMode: "eager" */ "/Users/ghadygergis/Documents/scitrials-sst/node_modules/@fortawesome/fontawesome-svg-core/styles.css");
;
import(/* webpackMode: "eager", webpackExports: ["Provider"] */ "/Users/ghadygergis/Documents/scitrials-sst/packages/website/src/components/ui/provider.tsx");
